import React from "react";
import {
  createStyles,
  Box,
  Stack,
  Text,
  Center,
  Image,
  Space,
  Group,
  Anchor,
  List,
  Button,
  Accordion,
} from "@mantine/core";

import { Link, useNavigate } from "react-router-dom";

function SupportPage({ children, ...otherProps }) {
  const { classes } = useStyles();
  const navigation = useNavigate();
  return (
    <Box className={classes.container} {...otherProps}>
      {/* Header */}
      <Box className={classes.root}>
        <Box className={classes.grid}>
          <Box className={classes.section}>
            <Center px={50} pt={30} pb={10}>
              <Stack spacing={0} justify='center'>
                <Center>
                  <Group spacing={10} align="center" sx={{ cursor: "pointer" }} onClick={() => navigation("/")}>
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "50%",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "linear-gradient(135deg, #B049C5, #6A59D8)",
                      }}
                    >
                      <Image
                        src="/flipwave-ico.svg"
                        alt="FlipWave"
                        width={30}
                        height={30}
                        sx={{ objectFit: "contain" }}
                      />
                    </Box>
                    <Text weight={800} size={30} sx={{ color: "#7749FD" }}>
                      FlipWave
                    </Text>
                  </Group>
                </Center>
              </Stack>
            </Center>
          </Box>
          <Space h={30} />
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid}>
            <Box className={classes.section} mt={50} px={25}>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26} sx={{ color: "#000000" }}>
                  Support Center
                </Text>
                <Text weight={400} size={18} sx={{ color: "#87808A" }}>
                  Subscription & Billing
                </Text>
              </Stack>

              <Accordion multiple={true}>
                <Accordion.Item value='Cancel a subscription'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Cancel a subscription
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <List type='ordered' withPadding>
                      <List.Item>Open the iOS Settings app.</List.Item>
                      <List.Item>Tap on your account name at the top.</List.Item>
                      <List.Item>Tap Subscriptions.</List.Item>
                      <List.Item>Tap on FlipWave in the list of subscriptions.</List.Item>
                      <List.Item>Tap Cancel Subscription.</List.Item>
                    </List>
                    For more information, please{" "}
                    <Anchor href='https://support.apple.com/en-us/118428' target='_blank' sx={{ color: "#7749FD" }}>
                      check here
                    </Anchor>
                  </Accordion.Panel>
                </Accordion.Item>

                <Accordion.Item value='Request a refund'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Request a refund
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <List type='ordered' withPadding>
                      <List.Item>
                        Sign in to{" "}
                        <Anchor href='https://reportaproblem.apple.com' target='_blank' sx={{ color: "#7749FD" }}>
                          reportaproblem.apple.com
                        </Anchor>
                      </List.Item>
                      <List.Item>
                        Tap or click "I'd like to," then choose "Request a refund."
                      </List.Item>
                      <List.Item>
                        Choose the reason why you want a refund, then choose Next.
                      </List.Item>
                      <List.Item>
                        Find the recent subscription item of the app FlipWave, then choose
                        Submit.
                      </List.Item>
                    </List>
                    <Text weight={400}>
                      If your request is approved by Apple, it might take additional time
                      for the funds to return to your payment method.
                    </Text>
                    <Text weight={400}>
                      For more information, please{" "}
                      <Anchor
                        href='https://support.apple.com/en-gb/HT204084'
                        target='_blank'
                        sx={{ color: "#7749FD" }}
                      >
                        check here
                      </Anchor>
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>

                <Accordion.Item value='Restoring a previous purchase'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Restoring a previous purchase
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text weight={400}>
                      If you are installing FlipWave on a new device, you may need to
                      restore a previous purchase.
                    </Text>
                    <List type='ordered' withPadding>
                      <List.Item>Tap the gear icon to open settings.</List.Item>
                      <List.Item>
                        Tap on "Upgrade to Premium" at the top of settings.
                      </List.Item>
                      <List.Item>Tap the "Restore" on the bottom.</List.Item>
                    </List>
                  </Accordion.Panel>
                </Accordion.Item>

                <Accordion.Item value='Does FlipWave support Family Sharing'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Does FlipWave support Family Sharing?
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text weight={400}>
                      Yes, all of the in-app purchases support family sharing.
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>

                <Accordion.Item value='Can I use FlipWave without a Premium membership'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Can I use FlipWave without a Premium membership?
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text weight={400}>
                      Yes! The FlipWave app can be used without a Premium membership for
                      as long as you'd like.
                    </Text>
                    <Text weight={400}>
                      The FlipWave Premium membership unlocks the app's full features, but
                      it's completely optional.
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>
              </Accordion>

              <Stack spacing={10} justify='left' pl={20}>
                <Text weight={400} size={18} sx={{ color: "#87808A" }}>
                  Get in touch with us, we'd love to hear from you! We're here to help or
                  answer any additional questions.
                </Text>
                <Box mt={30}>
                  <Button
                    radius='xl'
                    size='md'
                    w={200}
                    onClick={() => navigation("/contact")}
                    sx={{
                      backgroundColor: "#E63230",
                      "&:hover": { backgroundColor: "#d42d2b" },
                    }}
                  >
                    Contact Us
                  </Button>
                </Box>
              </Stack>
            </Box>
            <Space h={30} />
            <Space h={440} />
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Box className={classes.containerFooter}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                Made with love by Anatoli Niculeac<sup>&copy;</sup> 2026
              </Text>
              <Group spacing={10} p={20} position='right'>
                <Anchor component={Link} to={"/support"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Support
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/terms"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Terms of use
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/privacy"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Privacy Policy
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/contact"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Contact
                  </Text>
                </Anchor>
              </Group>
              <Space h={10} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default SupportPage;

const useStyles = createStyles({
  root: {
    height: "100%",
    width: "100%",
    overflowX: "hidden",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    "@media (max-width: 768px)": { width: "100%" },
    width: "100%",
    height: "100%",
    background: "linear-gradient(180deg, #FBE1F6 0%, #FCE9F9 100%)",
  },
  containerTwo: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    "@media (max-width: 768px)": { width: "100%" },
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
  },
  containerFooter: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    "@media (max-width: 768px)": { width: "100%" },
    width: "100%",
    height: "100%",
    background: "linear-gradient(180deg, #FCE9F9 0%, #FBE1F6 100%)",
  },
  section: {
    maxWidth: 980,
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: 25,
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },
  sectionTwo: {
    maxWidth: 980,
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },
  grid: {
    display: "grid",
    width: "100%",
    height: "100%",
    gridTemplateColumns: "auto",
    gridTemplateRows: "auto",
    "@media (max-width: 1023px)": {
      gridTemplateColumns: "auto",
      justifyContent: "stretch",
    },
    "@media (min-width: 1600px)": {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto",
      WebkitTransition: "300ms",
    },
  },
  link: {
    whiteSpace: "nowrap",
    textDecoration: "none",
    ":last-child": { borderRight: "none" },
    transition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    ":hover": {
      textDecoration: "none",
      opacity: 0.7,
    },
  },
});
